module.exports = __webpack_public_path__ + "static/media/wine-glass-alt.dfdfab55.svg";